import React from "react";
import { useRouter } from "next/navigation";
import Picture from "@/components/ratl/utility/Picture";
import { FlipWords } from "@/components/ui/flip-words";
import OnlineStatusIndicator from "@/components/ui/status-indicator";

interface FooterLinksProps {
  words: string[];
}

const FooterLinks: React.FC<FooterLinksProps> = ({ words }) => {
  const router = useRouter();
  return (
    <ul className="flex flex-col md:flex-row flex-wrap gap-2 md:gap-4 items-center justify-center text-light-body-text text-sm mt-3 w-full text-center">
      <li className="flex gap-1">
        &copy; 2025 ratl.ai <span className="hidden md:block">|</span>
      </li>
      <li onClick={() => router.push("/terms-of-use")} className="cursor-pointer flex gap-1">
        Terms of Use <span className="hidden md:block">|</span>
      </li>
      <li onClick={() => router.push("/privacy-policy")} className="cursor-pointer">
        Privacy Policy
      </li>
      <span className="hidden md:block">|</span>
      <Picture size={[19]} src={"/icons/footer/heart.png"} className="" />
      <div className="flex items-center">
        <FlipWords words={words} />
      </div>
      <div className="flex items-center gap-2">
        <OnlineStatusIndicator />
        <a href="https://ratl.betteruptime.com/">System Status</a>
      </div>
    </ul>
  );
};

export default FooterLinks;
